import { newRowId } from "./rowKeys";

// Editing a section title must never change its React identity or merge other sections.
export const withGroupIds = items => {
  const ids = new Map();
  return (items || []).map(item => {
    const name = item.group || "";
    if (!ids.has(name)) ids.set(name, newRowId());
    return { ...item, _groupId: ids.get(name) };
  });
};

export const quoteGroups = items => {
  const groups = new Map();
  (items || []).forEach(item => { if (!groups.has(item._groupId)) groups.set(item._groupId, { id: item._groupId, name: item.group || "" }); });
  return [...groups.values()];
};

export const sectionValidation = items => {
  const names = quoteGroups(items).map(group => group.name.trim());
  if (names.some(name => !name)) return "Indica un titolo per ogni sezione del preventivo.";
  if (new Set(names.map(name => name.toLocaleLowerCase("it-IT"))).size !== names.length) return "Le sezioni devono avere titoli distinti: rinomina la sezione duplicata prima di salvare.";
  return "";
};

export const serializableQuoteItems = items => (items || []).map(({ _groupId, ...item }) => ({ ...item, group: item.group.trim() }));